export enum IOrderStatus {
    None = 0,
    New = 1,
    Confirmed = 2,
    Cancelled = 3,
    Paid = 4,
}